export default class Misc {
  /**
   * Returns true if the value is null or empty
   * @param value
   * @returns
   */
  static isNullOrEmpty = (value: any) => {
    if (value === null || value === undefined || value === "") {
      return true;
    }
    return false;
  };

  /**
   * Converts a number to a USD formatted string
   * @param amount
   * @returns
   */
  static toUSD = (amount: number): string => {
    if (this.isNullOrEmpty(amount)) return "$0.00";

    return amount.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  };

  /**
   *
   * @param arr
   * @returns
   */
  static isArrayEmpty = (arr: any[]): boolean => {
    return !Array.isArray(arr) || arr.length === 0;
  };

  /**
   *
   */
  static validEmailFormat = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  /**
   *
   */
  static validPasswordFormat = (password: string): boolean => {
    // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    return passwordRegex.test(password);
  };

  /**
   *
   */
  static formatEIN = (ein: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + ein).replace(/\D/g, "");

    // Format the EIN as XX-XXXXXXX
    const match = cleaned.match(/^(\d{2})(\d{7})$/);
    if (match) {
      return `${match[1]}-${match[2]}`;
    }
    return ein; // Return the original input if it doesn't match the expected format
  };

  /**
   *
   */
  static formatSSN = (ssn: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + ssn).replace(/\D/g, "");

    // Format the SSN as XXX-XX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{2})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return ssn; // Return the original input if it doesn't match the expected format
  };

  /**
   *
   */
  static formatPhoneNumber = (phoneNumber: string): string => {
    // Remove any non-digit characters
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");

    // Remove leading 1 if present
    const normalized =
      cleaned.length === 11 && cleaned.startsWith("1")
        ? cleaned.slice(1)
        : cleaned;

    // Format the phone number as (XXX) XXX-XXXX
    const match = normalized.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber; // Return the original input if it doesn't match the expected format
  };

  /**
   *
   */
  static generateUsername(name: string): string {
    const randomNum = Math.floor(Math.random() * 10000); // Generate a random number up to 9999
    return `${name}${randomNum}`;
  }
}
